// extracted by mini-css-extract-plugin
export default {"snippet":"_3BjmAhUZ"};